import { create } from 'zustand'

export interface timezoneType { value: string, offset: number, status: string }
const emptyTz: timezoneType = { value: 'na', offset: 0, status: 'inactive' }

interface AuthState {
    user: string
    setUser: (user: string) => void
    token: string
    setToken: (token: string) => void
    userIP: string
    setUserIP: (s: string) => void
    timezone: timezoneType
    setTimezone: (t: timezoneType) => void
    reset: () => void
}

const useStore = create<AuthState>((set) => ({
    user: '',
    setUser: (user) =>
        set((state) => ({ ...state, user })),

    token: '',
    setToken: (token) =>
        set((state) => ({ ...state, token })),

    userIP: '',
    setUserIP: (userIP) =>
        set((state) => ({ ...state, userIP })),

    timezone: emptyTz,
    setTimezone: (tz: timezoneType) =>
        set((state) => ({ ...state, timezone: tz })),

    reset: () =>
        set((state) => ({
            ...state,
            user: '',
            token: '',
            userIP: '',
            timezone: emptyTz,
        })),
}))

export default useStore
